import { Controller } from "@hotwired/stimulus"

// Opens the visit detail modal when a row is clicked; closes on overlay or close button.
export default class extends Controller {
  static targets = ["backdrop"]

  connect() {
    this.backdropTarget.classList.add("hidden")
    this.backdropTarget.classList.remove("flex")
  }

  open() {
    this.backdropTarget.classList.remove("hidden")
    this.backdropTarget.classList.add("flex", "flex-col", "items-center", "justify-center")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.backdropTarget.classList.add("hidden")
    this.backdropTarget.classList.remove("flex", "flex-col", "items-center", "justify-center")
    document.body.style.overflow = ""
  }
}
